'use client';

import { languages } from '@/app/i18n/settings';
import { createContext } from 'react';

export type Language = (typeof languages)[number];
export interface ILanguageContext {
  lang: Language;
  setLanguage: (lang: Language) => void;
}

const LanguageContext = createContext<ILanguageContext>({ lang: 'en', setLanguage: () => {} });

export default LanguageContext;
